import React, { useState, useImperativeHandle, useEffect, forwardRef, useRef, Fragment } from 'react'
import Api from '../../../../_helpers/Api'

//images
import supplierImage from '@/assets/img/storage/icons/add-supplier.svg'
import uploadImage from '@/assets/img/storage/icons/upload.svg'
import closeIcon from '../../../../assets/img/icons/close.png'
import deleteIcon from "@/assets/img/reservations/icons/delete.svg"
import loader from '../../../../assets/img/loader.svg'
import { trans } from '../../../../_providers/Translation'
import PhoneField from '@/components/partials/PhoneField'
import Skeleton from 'react-loading-skeleton'
import { Checkbox, FormControlLabel, Radio } from '@mui/material'
function AddOrEdit(props, ref) {

    const imageRef = useRef(null)

    const [popup, setPopup] = useState({
        overlay: false,
        modal: false,
        edit: false,
        editId: null,
        data: null,
        logo: null,
        loading: false,
        loadingData: false,
        addresses: [],
    })

    const [validations, setValidations] = useState(null)

    useImperativeHandle(ref, () => ({
        add: () => {
            setPopup(prev => ({
                ...prev,
                edit: false,
                loading: false,
                data: null,
                addresses: [{ address: '', is_primary: true }]
            }))
            handleShow()
        },
        edit: (id) => {
            setPopup(prev => ({
                ...prev,
                edit: Math.random().toString(),
                editId: id,
                loading: false
            }))
            handleShow()
        },
        hide: () => {
            handleHide()
        }
    }))

    const handleAttachLogo = (e) => {
        let attachments = Array.from(e.target.files)
        attachments.map((t, i) => {
            let tmppath = URL.createObjectURL(e.target.files[i])
            attachments[i] = { t, tmppath }
        })
        setPopup(prev => ({
            ...prev,
            logo: attachments
        }))
    }

    const FileSize = size => {
        return size / 1000
    }

    const handleOpenLogo = (e) => {
        e.preventDefault()
        let input = document.getElementById(`logo`)
        input.click()
    }

    const openModal = image => {
        console.log(image)
        let modal = imageRef.current

        modal.show(image)
    }

    function setLoadingData(loading) {
        setPopup(prev => ({
            ...prev,
            loadingData: loading
        }))
    }

    // при редакция извлича текущите данни, за да се попълнят полетата
    useEffect(() => {
        if (popup.edit) {
            setLoadingData(true)

            Api.get(`suppliers/find?id=${popup.editId}`)
                .then(res => {
                    setPopup(prev => ({
                        ...prev,
                        data: res.data,
                        addresses: res.data.addresses && res.data.addresses.length > 0
                            ? res.data.addresses
                            : [{ address: '', is_primary: true }]
                    }))
                })
                .finally(() => {
                    setLoadingData(false)
                })
        }

    }, [popup.edit])


    const handleShow = () => {
        setPopup(prev => ({
            ...prev,
            overlay: true
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: true,
                modal: true
            }))
        }, 50)
    }

    const handleHide = e => {
        e.preventDefault()

        setPopup(prev => ({
            ...prev,
            modal: false,
            loading: false,
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: false,
                data: null,
                logo: null,
                modal: false
            }))

            document.getElementById("form").reset()
        }, 50)
    }

    const handleSave = e => {
        e.preventDefault()


        setPopup(prev => ({
            ...prev,
            loading: true,
        }))

        setValidations(null)

        let url

        if (popup.edit) {
            url = 'suppliers/edit'
        } else {
            url = 'suppliers/add'
        }

        let data = new FormData(e.target)

        if (popup.logo && popup.logo.length > 0 && popup.logo[0].t) {
            data.append('logo', popup.logo[0].t)
        }

        popup.addresses.forEach((addr, index) => {
            data.append(`addresses[${index}][address]`, addr.address || '')
            data.append(`addresses[${index}][is_primary]`, addr.is_primary ? '1' : '0')
            if (addr.id) {
                data.append(`addresses[${index}][id]`, addr.id)
            }
        })

        // при редакция - добавяме ID
        if (popup.edit) {
            data.append('id', popup.editId)
        }

        Api.post(url, data)
            .then(res => {

                if (popup.edit) {
                    props.handleUpdate(res.data)
                } else {
                    props.handleCreate(res.data)
                }

                handleHide(e)

                document.getElementById("form").reset()

            }).catch(error => {

                setPopup(prev => ({
                    ...prev,
                    loading: false,
                }))

                let _err = error.response

                if (_err && _err.status && _err.status == 422) {
                    for (let [input, err] of Object.entries(_err.data.errors)) {

                        setValidations(prevState => {
                            return { ...prevState, [input]: true }
                        })
                    }
                }

            })
    }

    const handleInputChange = e => {
        let name = e.target.name
        let value = e.target.value

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: value
            }
        }))
    }

    const handleAddAddress = () => {
        setPopup(prev => ({
            ...prev,
            addresses: [...prev.addresses, { address: '', is_primary: false }]
        }))
    }

    const handleRemoveAddress = (index) => {
        setPopup(prev => {
            const newAddresses = prev.addresses.filter((_, i) => i !== index)
            if (prev.addresses[index].is_primary && newAddresses.length > 0) {
                newAddresses[0].is_primary = true
            }
            return {
                ...prev,
                addresses: newAddresses
            }
        })
    }

    const handleAddressChange = (index, value) => {
        setPopup(prev => {
            const newAddresses = [...prev.addresses]
            newAddresses[index].address = value
            return {
                ...prev,
                addresses: newAddresses
            }
        })
    }

    const handleSetPrimaryAddress = (index) => {
        setPopup(prev => {
            const newAddresses = prev.addresses.map((addr, i) => ({
                ...addr,
                is_primary: i === index
            }))
            return {
                ...prev,
                addresses: newAddresses
            }
        })
    }

    return (
        <div className={`${popup.overlay ? 'visible' : ''} overlay`}>
            <form id="form" className={`${popup.modal ? 'show' : ''} popup-primary popup-supplier large`} onSubmit={handleSave}>
                <div className='head-new'>
                    <img src={supplierImage} alt="supplier" />
                    <div className='texts'>
                        <h2>
                            {popup.edit ? trans('headings.editSupplier') : trans('headings.addSupplier')}
                        </h2>
                        <p>
                            {trans('subheadings.addEditUniversal')}
                        </p>
                    </div>
                    <span className='close' onClick={handleHide}>

                    </span>
                </div>
                {popup.loadingData ?
                    <Skeleton count={8} height={45} />
                    :
                    <>
                        <div className='row'>
                            <div className='col'>
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor="name">
                                            {trans('labels.name')}
                                        </label>
                                        <input
                                            id="name"
                                            type="text"
                                            name="name"
                                            value={popup.data?.name || ''}
                                            onChange={handleInputChange}
                                            className={validations && validations.name ? 'validate' : ''}
                                        />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col'>
                                        <label htmlFor="website">
                                            {trans('labels.website')}
                                        </label>
                                        <input
                                            id="website"
                                            type="text"
                                            name="website"
                                            value={popup.data?.website || ''}
                                            onChange={handleInputChange}
                                            className={validations && validations.website ? 'validate' : ''}
                                        />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col">
                                        <label htmlFor="phone_number">
                                            {trans('labels.phone')}
                                        </label>
                                        <PhoneField
                                            codeValue={popup.data?.phone_country_code || '+359'}
                                            numberValue={popup.data?.phone_number}
                                            codeName="phone_country_code"
                                            numberName="phone_number"
                                            onCodeChange={e => {
                                                setPopup(prev => ({
                                                    ...prev,
                                                    data: {
                                                        ...prev.data,
                                                        'phone_country_code': e.target.value
                                                    }
                                                }))
                                            }}
                                            onNumberChange={e => {
                                                setPopup(prev => ({
                                                    ...prev,
                                                    data: {
                                                        ...prev.data,
                                                        'phone_number': e.target.value
                                                    }
                                                }))

                                            }}
                                            placeholder={trans('labels.phone')}
                                        />
                                    </div>
                                    <div className='col'>
                                        <label htmlFor="email">
                                            {trans('labels.email')}
                                        </label>
                                        <input
                                            id="email"
                                            type="text"
                                            name="email"
                                            value={popup.data?.email || ''}
                                            onChange={handleInputChange}
                                            className={validations && validations.email ? 'validate' : ''}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div
                                className='col'
                                style={{
                                    width: "180px",
                                    flexShrink: 0
                                }}
                            >
                                <div className='upload-logo'>
                                    {(popup.logo && popup.logo.length > 0) ? (
                                        popup.logo.map((a, i) => (
                                            <Fragment key={i}>
                                                {
                                                    a.logo_url && (
                                                        <img
                                                            src={a.logo_url}
                                                            className='uploaded-image'
                                                            alt="logo preview"
                                                        />
                                                    )
                                                }
                                                {
                                                    a.tmppath && (
                                                        <img
                                                            src={a.tmppath}
                                                            className='uploaded-image'
                                                            alt="logo preview"
                                                        />
                                                    )
                                                }
                                            </Fragment>
                                        ))
                                    ) : popup.data?.logo_url && typeof popup.data.logo_url === 'string' && popup.data.logo_url !== null ? (
                                        <img
                                            src={popup.data.logo_url}
                                            className='uploaded-image'
                                            style={{ maxHeight: '150px' }}
                                            alt="supplier logo"
                                        />
                                    ) : <div className='initial-look'>
                                        <img src={uploadImage} alt="upload" />
                                        <b>
                                            {trans('buttons.attachLogo')}
                                        </b>
                                        <p>
                                            Допустими формати:<br />  PNG, JPG и GIF
                                        </p>
                                    </div>}
                                    <div>
                                        <input
                                            id='logo'
                                            type="file"
                                            className='webImage'
                                            onChange={e => handleAttachLogo(e)}
                                            accept="image/*"
                                            name='logo'
                                            hidden
                                        />
                                        <button className={`button-add button-small ${popup.logo && popup.logo.length > 0 || popup.data?.logo ? '' : 'no-logo'}`} onClick={e => { e.preventDefault(); handleOpenLogo(e) }}>
                                            {trans('buttons.attachNewLogo')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <label>
                            {trans('labels.addresses')}
                        </label>
                        {popup.addresses && popup.addresses.map((addr, index) => (
                            <div key={`address-${index}`} className="supplier-address-container" style={{ marginBottom: '10px', position: 'relative' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <input
                                        type="text"
                                        value={addr.address || ''}
                                        onChange={(e) => handleAddressChange(index, e.target.value)}
                                        placeholder={trans('labels.enterAddress')}
                                        style={{ flex: 1 }}
                                        className={validations && validations[`addresses.${index}.address`] ? 'validate' : ''}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                size='small'
                                                name='primary_address'
                                            />
                                        }
                                        checked={addr.is_primary || false}
                                        onChange={() => handleSetPrimaryAddress(index)}
                                        label={trans('labels.primary')}
                                    />
                                    <button
                                        className='button-remove'
                                        disabled={popup.addresses.length === 1}
                                        style={{
                                            width: "40px",
                                            height: "40px",
                                            padding: 0,
                                            minWidth: "initial",
                                            flexShrink: 0,
                                        }}
                                        onClick={() => handleRemoveAddress(index)}
                                    >
                                        <img
                                            src={deleteIcon}
                                            alt="delete"
                                        />
                                    </button>
                                </div>
                            </div>
                        ))}
                        <button
                            type="button"
                            className="button-small button-add"
                            onClick={handleAddAddress}
                            style={{ marginTop: '5px' }}
                        >
                            {trans('buttons.addAddress')}
                        </button>
                    </>
                }
                <div className="footer align-right">
                    {popup.loading ?
                        <img src={loader} alt="loading" />
                        :
                        <>
                            <button className="button" onClick={handleHide}>
                                {trans('buttons.cancel')}
                            </button>
                            <button className="button button-primary" type="submit">
                                {trans('buttons.save')}
                            </button>
                        </>
                    }
                </div>
            </form >
        </div >
    )
}

export default forwardRef(AddOrEdit)